var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountBalanceBankFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 16.937v-5.064q0-.43.287-.721A.96.96 0 0 1 6 10.86q.424 0 .713.29a.99.99 0 0 1 .287.722v5.064a.99.99 0 0 1-.287.721.96.96 0 0 1-.713.291.96.96 0 0 1-.713-.29.99.99 0 0 1-.287-.722m6 0v-5.064q0-.43.287-.721A.96.96 0 0 1 12 10.86q.424 0 .713.29a.99.99 0 0 1 .287.722v5.064a.99.99 0 0 1-.287.721.96.96 0 0 1-.713.291.96.96 0 0 1-.713-.29.99.99 0 0 1-.287-.722M3 22a.96.96 0 0 1-.712-.291.99.99 0 0 1-.288-.722q0-.43.288-.721A.96.96 0 0 1 3 19.975h18q.424 0 .712.29a.99.99 0 0 1 .288.722.99.99 0 0 1-.288.722A.96.96 0 0 1 21 22zm14-5.063v-5.064q0-.43.288-.721A.96.96 0 0 1 18 10.86q.424 0 .712.29a.99.99 0 0 1 .288.722v5.064a.99.99 0 0 1-.288.721.96.96 0 0 1-.712.291.96.96 0 0 1-.712-.29.99.99 0 0 1-.288-.722m4-8.102H2.9a.86.86 0 0 1-.637-.265A.89.89 0 0 1 2 7.924v-.557q0-.279.138-.48.137-.204.362-.33l8.6-4.354Q11.525 2 12 2t.9.203l8.55 4.329q.274.125.413.38.137.252.137.531v.38a.99.99 0 0 1-.288.721.96.96 0 0 1-.712.291"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBalanceBankFill);
export default __webpack_public_path__ + "static/media/account_balance_bank_fill.2ce658d3c70ccb044216bb87579e8471.svg";
export { ForwardRef as ReactComponent };